module.exports = __webpack_public_path__ + "static/img/logo_takima.6a8c2ed7.png";